<template>
    <div>
        <div class="main-content m-b-sm invitate-code-content">
            企业邀请码:
            <span class="invitate-code" :class="{'code_is_active':company.is_active === 1}">{{invitate_code}}</span>
            <button type="button" @click="activeCode(1)" class="btn btn-success btn-sm" v-if="company.is_active === -1">开启邀请</button>
            <button type="button" @click="activeCode(-1)" class="btn btn-defaul btn-sm" v-if="company.is_active === 1">关闭邀请</button>
        </div>
        <div class="main-content clearfix">
            <div class="row">
                <div class="col-xs-12">
                    <div class="row p-b-sm table-filter">
                        <div class="col-sm-4 col-xs-12 ">
                            <h4 class="table-name">HR管理</h4>
                        </div>
                        <div class="col-sm-4 col-xs-12 ">
                            <div class="row">
                                状态：
                                <label for="status-online">在职</label>
                                <input type="checkbox" name="status" value="1" v-model="status" id="status-online">
                                <label for="status-offline">离职</label>
                                <input type="checkbox" name="status" value="-1" v-model="status" id="status-offline">
                            </div>
                        </div>
                        <div class="col-xs-12 col-sm-4">
                            <div class="row">
                                <div class="col-sm-4 col-xs-12 text-right">
                                    搜索：
                                </div>
                                <div class="col-sm-8 col-xs-12 n-p-l">
                                    <input type="text" class="input input-sm" placeholder="输入姓名、手机号进行搜索" required="required" v-model.trim="search" autocomplete="off">
                                </div>
                            </div>
                        </div>
                    </div>
                    <div class="row">
                        <div class="col-xs-12">
                            <table class="table table-border">
                                <thead>
                                    <tr>
                                        <!-- <th>序号</th> -->
                                        <th>姓名</th>
                                        <th>手机号</th>
                                        <th>测评量</th>
                                        <th>报告量</th>
                                        <th>状态</th>
                                        <th>加入时间</th>
                                        <th>操作</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    <tr v-for="(hr,ind) in filterHrs" :key="hr._id">
                                        <!-- <td>{{ind+1}}</td> -->
                                        <td>{{hr.hr?hr.hr.realname:'-'}}</td>
                                        <td>{{hr.hr?hr.hr.phone:'-'}}</td>
                                        <td>{{hr.invitation_number}}</td>
                                        <td>{{hr.report_number}}</td>
                                        <td>
                                            <span class="btn btn-xs btn-default" :class="{'btn-success': hr.status === 1}">{{hr.status== -1 ?'离职':'在职'}}</span>
                                        </td>
                                        <td>{{hr.join_time | format('YYYY-MM-DD',hr.join_time)}}</td>
                                        <td>
                                            <router-link :to="{'name':'CompanyHRDashboard','params':{'hr':hr.hr._id}}" class="btn btn-xs btn-info">统计</router-link>
                                            <span class="btn btn-xs btn-primary" @click="setManager(hr)" v-if="hr.status===1 && hr.hr.role === 2">设为管理</span>
                                            <span class="btn btn-xs btn-primary" @click="updateRange(hr)" v-if="hr.status===1 && hr.hr.role === 3">管理范围</span>
                                            <span class="btn btn-xs btn-default" @click="cancelManager(hr)" v-if="hr.status===1 && hr.hr.role === 3">取消管理</span>
                                            <span class="btn btn-xs btn-default" @click="leaveHr(hr)" v-if="hr.status===1">离职</span>
                                        </td>
                                    </tr>
                                </tbody>
                            </table>
                        </div>
                    </div>
                </div>
            </div>
        </div>
        <!-- import -->
        <div v-if="modal.show">
            <div class="overlay">
            </div>
            <transition name="fade">
                <div class="modal">
                    <div class="modal-header">
                        {{modal.title}}
                        <span class="close" @click="closeRangeSetPanel">X</span>
                    </div>
                    <div class="modal-body w-sm">
                        <div class="col-xs-12">
                            <tree-view :model="orgs" func="4" @select="select"></tree-view>
                        </div>
                        <div class="col-xs-12 actions text-center p-t-b-sm">
                            <button type="button" :disabled="!modal.actions.is_active" class="btn-default btn btn-sm m-r-lg" @click="closeRangeSetPanel">取消</button>
                            <button type="button" :disabled="!modal.actions.is_active" class="btn-primary btn btn-sm" @click="saveRange">确定</button>
                        </div>
                    </div>
                </div>
            </transition>
        </div>
        <!-- import  end -->
    </div>
</template>

<script>
import { mapGetters } from "vuex";
import Vue from "vue";
import { deepCopy } from "../../plugins/utils";
import User from "../../resource/user";
import Company from "../../resource/company";
import Organization from "../../resource/organization";
import TreeView from "../blocks/tree";
export default {
  components: {
    TreeView
  },
  data: function() {
    return {
      status: [1, -1],
      search: "",
      join_active: false,
      error: {
        invite_code: ""
      },
      hrs: [],
      orgs: [],
      view_orgs: {},
      hr: {},
      modal: {
        show: false,
        title: "设定管理范围",
        actions: {
          is_active: true
        }
      }
    };
  },
  computed: {
    filterHrs: function() {
      let that = this;
      return that.hrs
        .filter(
          hr => that.status.length === 2 || hr.status === Number(that.status[0])
        )
        .filter(
          hr =>
            !that.search ||
            hr.hr.realname.indexOf(that.search) >= 0 ||
            hr.hr.phone.indexOf(that.search) >= 0
        )
        .sort((a, b) => b.status - a.status);
    },
    ...mapGetters({
      user: "loginUser"
    }),
    company: function() {
      let that = this;
      return that.user.user_company;
    },
    invitate_code: function() {
      let that = this;
      return that.company.is_active === 1
        ? that.company.invitate_code
        : "******";
    }
  },
  created: function() {
    let that = this;
    if (that.user.category !== 2) {
      that.$router.replace("/");
    } else {
      document.title = `HR管理-企业控制台|${that.global.name}`;
    }
  },
  methods: {
    loadHrs: function() {
      let that = this;
      Company.hr({}, {}).then(
        res => {
          let data = res.body;
          if (data.code === 0) {
            that.hrs = data.result;
          } else {
            alert(data.msg);
          }
        },
        res => {}
      );
    },
    loadOrgs: function() {
      let that = this;
      Organization.query({}).then(
        res => {
          let data = res.body;
          if (data.code === 0) {
            let orgs = data.result || [];
            let _orgs = [];
            that.view_orgs = {};
            orgs.forEach(org => {
              // 自身检查
              let tmp = that.view_orgs[org._id];
              if (!tmp) {
                // 不存在
                tmp = org;
                tmp.children = [];
                tmp.is_opened = -1;
                tmp.is_locked = -1;
                tmp.is_selected = -1;
                that.view_orgs[org._id] = tmp; // 设置
              } else {
                // 存在
                tmp.name = org.name;
                tmp.pid = org.pid;
                tmp.sort = org.sort;
              }
              if (tmp.pid) {
                //父级检查
                let p = that.view_orgs[org.pid];
                if (!p) {
                  // 不存在
                  p = {
                    _id: org.pid,
                    children: [],
                    is_opened: -1,
                    is_locked: -1,
                    is_selected: -1
                  };
                  that.view_orgs[org._id] = p; // 设置
                }
                p.children.push(tmp);
              } else {
                _orgs.push(tmp);
              }
            });
            let sort = function(ogs) {
              ogs.sort((a, b) => {
                return a.sort - b.sort;
              });
              ogs.forEach(og => sort(og.children));
            };
            sort(_orgs);
            that.orgs = _orgs;
          } else {
            Toast.alert(data.msg);
          }
        },
        res => {}
      );
    },
    leaveHr: function(hr) {
      let that = this;
      if (
        confirm(
          `您要对“${hr.name}”hr进行离职操作吗？\n离职后,${hr.name}将不能继续使用公司资源，历史记录仅公司管理员可以查阅！！！`
        )
      ) {
        Company.leave({ id: that.company._id, hr: hr.hr._id }, {}).then(
          res => {
            let data = res.body;
            if (data.code === 0) {
              alert("操作成功");
              that.loadHrs();
            } else {
              alert(data.msg);
            }
          },
          res => {}
        );
      }
    },
    activeCode: function(type) {
      if (confirm(`您要${type === 1 ? "开启" : "关闭"}企业邀请码吗？`)) {
        let that = this;
        Company[type === -1 ? "close" : "open"]({}, {}).then(
          res => {
            let data = res.body;
            if (data.code === 0) {
              that.$store.dispatch("getSession");
              alert(`${type === 1 ? "开启" : "关闭"}邀请成功`);
            } else {
              alert(data.msg);
            }
          },
          res => {}
        );
      }
    },
    select: function(org) {
      const that = this;
      let revChildren = function(p) {
        // 递归处理下级数据
        if (p.children && p.children.length > 0) {
          p.children.forEach(function(c) {
            c.is_selected = org.is_selected;
            revChildren(c);
          });
        }
      };
      let revParent = function(p) {
        // 递归处理上级数据
        if (p.pid) {
          let pre = that.view_orgs[p.pid];
          if (p.is_selected === 0) {
            // 取消选中
            pre.is_selected = 0;
            revParent(pre);
          } else {
            let f = 1;
            for (let prop of pre.children) {
              if (prop.is_selected === 0) {
                f = 0;
                break;
              }
            }
            if (f === 1) {
              pre.is_selected = 1;
              revParent(pre);
            }
          }
        }
      };
      revChildren(org);
      revParent(org);
    },
    setManager: function(hr) {
      const that = this;
      that.hr = hr;
      that.modal.show = true;
    },
    updateRange: function(hr) {
      const that = this;
      that.hr = hr;
      that.hr.hr.range.forEach(r => {
        let org = that.view_orgs[r];
        org && ((org.is_selected = 1), that.select(org));
      });
      that.modal.show = true;
    },
    cancelManager: function(hr) {
      const that = this;
      if (confirm(`您要取消“${hr.hr.realname}”的管理员角色吗？`)) {
        Company.cancelManager({ hr: hr.hr._id }, {}).then(res => {
          // 处理程序
          let data = res.body;
          if (data.code === 0) {
            alert("设置成功");
            that.loadHrs();
          } else {
            alert(data.msg);
          }
        });
      }
    },
    saveRange: function() {
      const that = this;
      that.modal.actions.is_active = false;
      let range = [];
      let hr = that.hr;
      // let revSelect = function (org) {
      //     let all = 1;
      //     if (org.is_selected === 1) {
      //         if (org.children && org.children.length > 0) {
      //             org.children.forEach(c => {
      //                 if (revSelect(c) === 0) {
      //                     all = 0
      //                 }
      //             })
      //         } else {
      //             all = 1
      //         }
      //         org.all = all
      //     } else {
      //         org.all = 0
      //         all = 0
      //     }
      //     return all
      // }
      // that.orgs.forEach(revSelect)
      let revRange = function(org) {
        if (org.is_selected === 1) {
          range.push(org._id);
        }
        if (org.children && org.children.length > 0) {
          org.children.forEach(revRange);
        }
      };
      that.orgs.forEach(revRange);
      if (range.length == 0) {
        alert("请设置管理范围");
        that.modal.actions.is_active = true;
        return;
      }
      var resolve = res => {
        // 处理程序
        let data = res.body;
        if (data.code === 0) {
          alert("设置成功");
          that.closeRangeSetPanel();
          that.loadHrs();
        } else {
          alert(data.msg);
        }
        that.modal.actions.is_active = true;
      };
      if (hr.hr.role === 2) {
        // hr
        Company.setManager({ hr: hr.hr._id }, { range }).then(resolve);
      } else {
        // manager
        Company.updateRange({ hr: hr.hr._id }, { range }).then(resolve);
      }
    },
    closeRangeSetPanel: function() {
      const that = this;
      that.modal.show = false;
      for (let prop in that.view_orgs) {
        if (that.view_orgs.hasOwnProperty(prop)) {
          that.view_orgs[prop].is_selected = -1;
        }
      }
    }
  },
  mounted: function() {
    let that = this;
    that.loadHrs();
    that.loadOrgs();
  }
};
</script>
<style lang="less" scoped>
.invitate-code-content {
  padding-top: 10px !important;
  padding-bottom: 10px !important;
  .invitate-code {
    padding-left: 10px;
    padding-right: 10px;
    &.code_is_active {
      color: #42b983;
    }
  }
}
</style>



// WEBPACK FOOTER //
// hr.vue?cfd11282